export default {
  创作即收益: "콘텐츠를 수익으로,<br />매달 입금되는 리워드",
  加入EBC创作者激励计划:
    "EBC 크리에이터 프로그램과 함께 콘텐츠로 매달 수익을 만들어 보세요",
  成为创作者: "지금 바로 시작하기",
  无限奖励: "크리에이터 프로그램",
  EBC创作者激励计划:
    "EBC 크리에이터 프로그램으로 영향력을 전 세계에 알리고, 매달 안정적인 부수입을 만들어 보세요.",
  推荐奖励: "네트워크 수익화",
  推荐新用户注册并交易: "신규 사용자 가입·거래 시, 보너스 매달 정산",
  内容变现: "콘텐츠 수익화",
  在EBC: "EBC에서는 지식이 단순한 힘을 넘어, 수익이 됩니다.",
  内容进阶: "콘텐츠 업그레이드",
  从本地创作到全球影响:
    "현지 콘텐츠에서 글로벌 영향력까지, 한 단계 도약하세요.",
  预计奖金: "월별 예상 보너스",
  均值估算仅供参考: "평균 추정치(참고용)",
  "800万交易者的信任首选": "500만 트레이더가 선택한 신뢰의 플랫폼",
  EBC用全球最佳券商的实力:
    "베스트 거래 플랫폼* EBC는 세계 최고의 거래 환경과 함께, 높은 보너스와 글로벌 톱티어 IP를 함께 지원합니다.",
  全方位媒体曝光: "전방위 미디어 노출",
  我们以全球媒体资源:
    "FC 바르셀로나 이벤트와 글로벌 미디어 채널을 활용해 개인 브랜드와 인지도를 높이세요.",
  全球最强交易环境: "최고 수준의 거래 환경",
  打造极致交易体验:
    "밀리초 단위 주문 체결, 기관급 유동성, 카피 트레이딩 기능으로 거래하세요.",
  专属客户经理: "전담 매니저 지원",
  我们为每位创作者配专属运营:
    "1:1 맞춤 가이드로 고품질 콘텐츠 제작을 돕고, 안정적인 지원과 수익 극대화를 실현합니다.",
  如何成为创作者: "크리에이터 참여 방법",
  从内容创作到奖励提现: "모든 단계에서 1:1 전담 지원을 받으세요.",
  立即加入: "지금 가입하기",
  注册提交资料: "등록 후 기본 정보 제출",
  发布专业内容: "EBC 관련 고품질 콘텐츠 제작·공유",
  获取月度奖励: "매월 리워드 정산 수령",
  活动须知: "프로그램 가이드라인",
  notices: [
    `1.콘텐츠 채널 보유 및 지속성<br />
              크리에이터는 독립적인 콘텐츠 채널, SNS 계정, 또는 커뮤니티 채널을
              보유하고 최소 3개월 이상의 콘텐츠 제작이 가능해야 합니다. 형식은
              전략 제공, 차트 분석, 영상 강의 등 제한 없이 가능합니다.`,
    `2.원본성·전문성·준법성 유지<br />
              콘텐츠는 반드시 원본이어야 하며, 전문성을 갖추고 관련 법규를
              준수해야 합니다. 표절, 무단 각색, 또는 금지된 콘텐츠 게시 시,
              플랫폼은 참여 자격과 모든 혜택을 박탈할 수 있습니다.`,
    `3.월별 정산 및 지급<br />
              달성 레벨에 따라 매월 성과를 정산하며, 자격을 갖춘
              크리에이터에게는 다음 달 첫째 주에 보상이 지급됩니다.`,
    `4.프로그램 중복 참여 제한<br />
              본 프로그램은 펀드매니저 프로그램, IB 지원 프로그램 등과 중복
              참여할 수 없습니다. 오직 하나의 프로그램만 참여 가능합니다.`,
    `5.우수 크리에이터 지원<br />
              플랫폼은 우수 크리에이터에게 전담 운영 지원을 제공하며, 콘텐츠
              제작 지원과 사용자 전환에 도움을 제공합니다. 문의는 고객센터 또는
              <a href="mailto:mkt@ebc.com">mkt@ebc.com</a>으로 연락 바랍니다.`,
    `6.공정성 보장 및 최종 해석권<br />
              당사 EBC는 본 프로그램의 최종 해석권을 보유하며, 위반이나 남용이
              발견될 경우 참여 자격을 취소할 수 있습니다.`,
  ],
  section4Tips:
    "*EBC는 World Finance에서 3년 연속 수상하며 2025년 세계 베스트 거래 플랫폼·가장 신뢰받는 브로커로 선정됐고, Online Money Awards 2025에서도 세계 베스트 CFD 브로커로 인정받았습니다.",
};
